export type OrganizationType =
  | 'individual'
  | 'academic_institution'
  | 'research_group'
  | 'student_organization'
  | 'ngo_nonprofit'
  | 'company_industry'

export type RequestType =
  | 'mentorship'
  | 'consulting'
  | 'collaboration'
  | 'training'
  | 'review'
  | 'career_advice'

export const ORGANIZATION_TYPE_OPTIONS: { value: OrganizationType; label: string }[] = [
  { value: 'individual', label: 'Individual' },
  { value: 'academic_institution', label: 'Academic Institution' },
  { value: 'research_group', label: 'Research Group' },
  { value: 'student_organization', label: 'Student Organization' },
  { value: 'ngo_nonprofit', label: 'NGO / Nonprofit' },
  { value: 'company_industry', label: 'Company / Industry' },
]

export const REQUEST_TYPE_OPTIONS: { value: RequestType; label: string }[] = [
  { value: 'mentorship', label: 'Mentorship' },
  { value: 'consulting', label: 'Consulting' },
  { value: 'collaboration', label: 'Research Collaboration' },
  { value: 'training', label: 'Training / Workshop' },
  { value: 'review', label: 'Peer Review / Feedback' },
  { value: 'career_advice', label: 'Career Advice' },
]

export interface SeekerProfile {
  id: string
  company_name: string
  company_website: string
  industry: string
  company_size: string
  description: string
  logo_url: string
  organization_type: OrganizationType | ''
  interested_in: RequestType[]
  country: string
  city: string
  contact_name: string
  contact_email: string
  contact_phone: string
  contact_title: string
  verification_status: 'pending' | 'verified' | 'rejected'
  is_verified: boolean
  verified_at: string | null
  hiring_for: string[]
  preferred_work_types: string[]
  user_email: string
  user_first_name: string
  user_last_name: string
  profile_picture_url: string | null
  created_at: string
  updated_at: string
}

export interface SeekerProfileListItem {
  id: string
  company_name: string
  company_website: string
  industry: string
  company_size: string
  description: string
  logo_url: string
  organization_type: OrganizationType | ''
  country: string
  city: string
  is_verified: boolean
  user_first_name: string
  user_last_name: string
  profile_picture_url: string | null
}
